import Config from '../config/Config'
import LocalStorageUtils from './LocalStorageUtils'

export type OAuthValidation = { success: true; code: string } | { success: false; error: string }

export function generateAndSaveOAuthState() {
  const state = crypto.randomUUID()
  const nonce = crypto.randomUUID()
  LocalStorageUtils.saveOAuthState(state)
  LocalStorageUtils.saveOAuthNonce(nonce)
  return { state, nonce }
}

export function buildWebEamLoginUrl(state: string, nonce: string): string {
  if (!Config.WEB_EAM_BASE_URL || !Config.WEB_EAM_CLIENT_ID || !Config.WEB_EAM_REDIRECT_URI) {
    console.error('Missing OAuth configuration values:', {
      WEB_EAM_BASE_URL: Config.WEB_EAM_BASE_URL,
      WEB_EAM_CLIENT_ID: Config.WEB_EAM_CLIENT_ID,
      WEB_EAM_REDIRECT_URI: Config.WEB_EAM_REDIRECT_URI,
    })
    throw new Error('Missing OAuth configuration values')
  }

  const authorizePath = Config.WEB_EAM_REALM_PATH
    ? `/oauth2/${Config.WEB_EAM_REALM_PATH}/authorize`
    : '/oauth2/authorize'

  const base = `${Config.WEB_EAM_BASE_URL}${authorizePath}`
  const query = new URLSearchParams({
    client_id: Config.WEB_EAM_CLIENT_ID,
    state,
    scope: 'openid email',
    redirect_uri: Config.WEB_EAM_REDIRECT_URI,
    response_type: 'code',
    nonce,
  })

  const url = `${base}?${query.toString()}`
  return url
}

export function validateOAuthCallback(search: string): OAuthValidation {
  const params = new URLSearchParams(search)
  const code = params.get('code')
  const receivedState = params.get('state')

  const state = LocalStorageUtils.getOAuthState()
  const nonce = LocalStorageUtils.getOAuthNonce()
  LocalStorageUtils.removeOAuthState()
  LocalStorageUtils.removeOAuthNonce()

  if (!code || !receivedState) {
    return { success: false, error: 'Missing code/state in callback' }
  }

  if (!state || receivedState !== state) {
    return { success: false, error: 'Invalid OAuth state' }
  }

  if (!nonce) {
    return { success: false, error: 'Missing OAuth nonce' }
  }

  return { success: true, code }
}

export function getOAuthCodeFromQuery(search: string): string | undefined {
  const params = new URLSearchParams(search)
  return params.get('code') ?? undefined
}
